import {loadable} from 'router/routes';

const AuthCheckoutRedirect = loadable(() => import('./CheckoutRedirect'));

export default AuthCheckoutRedirect;
